<div class="plans-hero">
  <div class="brand">
    <img src="assets/images/lincsell_logo_white.png" width="32" height="22" alt="Lincsell">
    <span class="brand-name">Lincsell</span>
  </div>
  <div class="hero-copy">
    <div class="eyebrow">Free trial status</div>
    <h1>{{ getRemaintingTime() }} days left • keep momentum going</h1>
    <p>Lock in the plan that fits your store before the trial ends. Seamless upgrades, no downtime.</p>
    <div class="hero-actions">
      <button class="pill primary" (click)="goToPlanDetails()">Compare plans</button>
      <button class="pill ghost" (click)="goToHome()">Continue trial</button>
    </div>
  </div>
  <div class="clock">
    <img src="assets/images/clock.svg" width="64" alt="trial countdown">
  </div>
</div>

<div class="plans-shell">
  <div class="plans-header">
    <div>
      <p class="eyebrow">Upgrade today</p>
      <h2>Choose a subscription built for your growth</h2>
      <p class="hint">Pick monthly or yearly billing — switch anytime.</p>
    </div>
    <div class="billing-toggle">
      <button [class.active]="isMonthly" (click)="isMonthly = true">Monthly</button>
      <button [class.active]="!isMonthly" (click)="isMonthly = false">Yearly</button>
    </div>
  </div>

  <div class="grid justify-content-center plan-grid">
    <div 
      class="col-12 sm:col-6 md:col-4 lg:col-3 xl:col-3 p-2" 
      *ngFor="let plan of plans"
    >
      <div class="pricing-card flex flex-column">
        <div class="card-top">
          <div class="plan-title-row">
            <h3>{{ plan?.planName }}</h3>
            <span class="pill-badge" *ngIf="plan?.popularPlan">Popular</span>
          </div>
          <p class="description">{{ plan?.detail || 'Built to launch and scale your store.' }}</p>
        </div>

        <div class="card-price">
          <div class="price">
            <span class="amount">
              {{ (isMonthly ? plan?.monthlyPrice : plan?.yearlyPrice) | currency | currencySpacing }}
            </span>
            <span class="duration">/ {{ isMonthly ? 'month' : 'month (yearly)' }}</span>
          </div>
          <p class="billing">{{ isMonthly ? 'Billed monthly' : 'Billed annually (best value)' }}</p>
        </div>

        <div class="card-actions">
          <button 
            class="selected-btn w-full" 
            *ngIf="plan?.selected === true" 
            (click)="selectPlan(plan)"
          >Selected</button>

          <button 
            class="select-btn w-full" 
            *ngIf="plan?.selected === false && plan?.CTA!=='contact'" 
            (click)="selectPlan(plan)"
          >Choose {{ plan?.planName }}</button>

          <button 
            class="select-btn ghost w-full" 
            *ngIf="plan?.CTA==='contact'" 
            (click)="selectPlan(plan)"
          >Talk to us</button>

          <div class="details-row">
            <a (click)="goToPlanDetails()" class="details-link cursor-pointer">
              View full feature list <i class="pi pi-external-link"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="additional-options flex align-items-center flex-column">
    <label class="checkbox-container">
      <input type="checkbox" [(ngModel)]="showTrialMessage"/>
      <span class="checkbox-label">Don't show this again until my free trial ends</span>
    </label>
    <button class="continue-button" (click)="goToHome()">Continue using free trial</button>
  </div>
</div>
